export function buildUrl(uri: string) {
  const rootUrl = process.env.REACT_APP_BACKEND_URL;

  return `${rootUrl}${uri}`;
}
